const useReadCanBuyVoucher = product => {
  return product && product.sell_gift_voucher_online === 1 && product.vouchers != null && product.vouchers.length > 0;
};
export default useReadCanBuyVoucher;
